import { NgModule } from '@angular/core';
import { DataFieldGroupEditComponent } from './data-field-group-edit.component';
import { DataFieldGroupEditItemDialogComponent } from './dialog-edit-item/dialog-edit-item.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FormsModule } from '@angular/forms';
import { DataFieldGroupEditItemComponent } from './group-item/group-item.component';
import { DataFieldGroupEditItemService } from './data-field-group-edit.service';
import { DataFieldGroupEditItemDialogConfirmTypeConvertComponent } from './dialog-confirm-type-convert/dialog-confirm-type-convert.component';
import { DataFieldGroupEditItemPreSetOptionsComponent } from './pre-set-options/pre-set-options.component';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { CdkDrag, CdkDragHandle, CdkDropList } from '@angular/cdk/drag-drop';
import { FiToggleSwitchModule } from '@fi-shared/fi-toggle-switch/fi-toggle-switch.module';

@NgModule({
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        UtilitiesModule,
        MatButtonModule,
        MatDialogModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSlideToggleModule,
        MatSelectModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        CdkDropList,
        CdkDrag,
        CdkDragHandle,
        FiToggleSwitchModule,
    ],
    declarations: [
        DataFieldGroupEditComponent,
        DataFieldGroupEditItemDialogComponent,
        DataFieldGroupEditItemComponent,
        DataFieldGroupEditItemDialogConfirmTypeConvertComponent,
        DataFieldGroupEditItemPreSetOptionsComponent,
    ],
    providers: [DataFieldGroupEditItemService],
})
export class DataFieldGroupEditModule {}
